import React, { useEffect, useMemo, useState } from "react";
import { FaMagic } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getData } from "../services/axios.function";
import "../styles/Dashboard.css";

const CARD_CONFIG = [
  {
    key: "totalFestival",
    label: "Festival",
    bg: "#E8F3FF",
    fg: "#0B5ED7",
    icon: <FaMagic size={22} />,
    to: "/festival-type",
  }
];

const StatCard = React.memo(({ card, value, isLoading, onClick }) => (
  <div className="col-12 col-sm-6 col-lg-4" key={card.key}>
    <div
      className="h-100 p-3 rounded border bg-white d-flex align-items-center stat-card clickable"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? onClick() : null)}
    >
      <div
        className="me-3 icon-tile"
        style={{ backgroundColor: card.bg, color: card.fg }}
        aria-hidden
      >
        {card.icon}
      </div>
      <div className="flex-grow-1">
        <div className="stat-label">{card.label}</div>
        <div className="stat-value">
          {isLoading || value == null ? "—" : value}
        </div>
      </div>
    </div>
  </div>
));

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();

    const fetchCounts = async () => {
      try {
        setIsLoading(true);
        setError("");
        const res = await getData("api/dashboard/count", {
          signal: controller.signal,
        });

        if (res?.data?.isSuccess) {
          setStats(res.data.data || {});
        } else {
          setError(res?.data?.message || "Failed to load dashboard data");
        }
      } catch (err) {
        if (err.name !== "CanceledError") {
          setError(err?.message || "Something went wrong");
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchCounts();
    return () => controller.abort();
  }, []);

  const cards = useMemo(
    () =>
      CARD_CONFIG.map((c) => ({
        ...c,
        value: stats?.[c.key] ?? 0,
      })),
    [stats]
  );

  return (
    <div className="container-fluid">
      <div className="mb-4 d-flex justify-content-between align-items-end">
        <h4 className="m-0 dashboard-header-title">Dashboard</h4>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="row g-3">
        {cards.map((card) => (
          <StatCard
            key={card.key}
            card={card}
            value={card.value}
            isLoading={isLoading}
            onClick={() => navigate(card.to)}
          />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;